export default __webpack_public_path__ + "images/slide-background.f1e69d93aab2dcdee5e9dd3e922648f4.png";